



























import { defineComponent, ref } from '@vue/composition-api';
import sl from '@/serviceLocator';

export default defineComponent({
  props: {
    wordUuid: {
      type: String,
      required: true,
    },
    word: {
      type: String,
      required: true,
    },
  },
  setup(props, { emit }) {
    const server = sl.get('serverProxy');
    const actions = sl.get('globalActions');

    const updateWord = (newSpelling: string) => {
      emit('update:word', newSpelling);
    };

    const isSaving = ref(false);

    const closeEdit = () => {
      emit('close-edit');
    };

    const saveEdit = async () => {
      isSaving.value = true;
      try {
        await server.editWord(props.wordUuid, { word: props.word });
        actions.showSnackbar('Successfully updated word spelling');
      } catch (err) {
        actions.showErrorSnackbar(
          'Failed to update word spelling',
          err as Error
        );
      } finally {
        isSaving.value = false;
        closeEdit();
      }
    };

    return {
      updateWord,
      isSaving,
      saveEdit,
      closeEdit,
    };
  },
});
